import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { useParams } from 'react-router-dom';
import './styles/TransferInventoryPage.css';
import { useNavigate } from 'react-router-dom'; 

const ExtraFeeFormPage = () => {
    const { extraFeeId } = useParams(); 
    const [extraFee, setExtraFee] = useState(null);
    const [price, setPrice] = useState('');
    const [itemType, setItemType] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        api.post('/utils/extrafee/getExtraFeeFromId', { data: { extraFeeId: extraFeeId }})
          .then(response => {
            const extraFeeData = response.data.data.extraFee; 
            setExtraFee(extraFeeData);
            setItemType(extraFeeData.Type.type_name); 
            setPrice(extraFeeData.fee_amount); 
        })
          .catch(error => console.error('Error fetching cost data:', error));
        
    }, [extraFeeId]);
    
    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };
    
    const handlePriceChange = (e) => {
        const value = e.target.value.replace(/\./g, '');
        if (value === '') {
            setPrice(0);
        } else {
            e.target.value = formatCurrency(value); 
            setPrice(value); 
        }
    };

    const validateForm = () => {
        const errors = {};
        if (price === 0) errors.price = 'Price is required';
        return errors;
    };
   
    const handleSubmit = () => {
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }
            
            const extraFeeData = {
                data: {
                    extraFeeData: {
                        extra_fee_id: extraFee.extra_fee_id,
                        fee_amount: price
                    },
                },
            };

            console.log(extraFeeData);
        
            api.post(`utils/extrafee/update`, extraFeeData)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
            })
            .catch(error => {
                console.error('Error updating price:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
        }
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Price Edit</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Item Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Extra Time Type</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"
                                            value={itemType} 
                                            readOnly
                                        />
                                    </td> 
                                </tr>
                                <tr>
                                    <td>
                                        <label>Extra Time Fee</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text" 
                                            value={formatCurrency(price)}      
                                            onChange={handlePriceChange} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    {errors.price && 
                                    <td>
                                        <div className="error-message">{errors.price}</div>
                                    </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="search-container">
                    <button className="profile-button" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
    );
};

export default ExtraFeeFormPage;
